<!-- 数据曲线 -->
<template>
    <div class="xcol ai-c ai-b">
        <div>
            <div class="pl-title lh50 xrow ai-c ai-c">
                <img src="../../../assets/category/te-1.png">
                <!-- <span class="color-m09 fs20 lsp2 fw-bd mgl10">{{ type }}实时变化数据(10秒刷新)</span> -->
                <span class="color-m09 fs20 lsp2 fw-bd mgl10">{{ type }}历史曲线</span>
                <span style="font-size: 20px; font-weight: bold;margin-left: 50px;margin-right: 10px;">起止时间</span>
                <el-date-picker v-model="queryDate" type="daterange" align="right" unlink-panels range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
                </el-date-picker>
                <el-button type="primary" icon="el-icon-search" style="margin-left: 10px;" class="mgl15"
                    @click="query">查询</el-button>
            </div>
            <!-- <p class="fw-bd lh34 mgr15">起止时间</p> -->

        </div>
        <div class="chart" id="container" ref="chart" style="margin-top: 10px;height: 200px;width: 100%;"></div>
    </div>
</template>

<script>
/**
 * 用于显示历史曲线
 */
import { Area } from '@antv/g2plot';
import { forEach } from "lodash"
import { get } from "@/utils/http";
import { formatDate } from '../../../common/util.js'
import { objectToParams } from '@/utils/util.js'
import { airDetailList } from '@/utils/config.js'
export default {
    name: 'historyChart',

    data() {
        return {
            nodeid: null,
            chart: null,
            option: null,
            node: null,
            interval: null,
            labels: [],
            dataList: [],
            EncoderId: "",
            queryDate: [
                new Date().getTime() - 3600 * 1000 * 24 * 30,
                new Date().getTime()
            ],
            valueParamList: [],
            queryName: '',
            type: ""
            //Group:""
        }
    },


    methods: {
        query(e) {


            const param = {
                // key:2304270013,
                key: this.nodeid,
                metrics: this.queryName,
                begin: this.queryDate == null ? '' : formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                end: this.queryDate == null ? '' : formatDate(this.queryDate[1], 'yyyy-MM-dd')
            };
            this.getChartData(param)
        },
        loadData(nodeid, queryName, valueParamList, type) {
            console.log("type", type)
            this.nodeid = nodeid;
            this.queryName = queryName;
            this.valueParamList = valueParamList;
            this.type = type;

            const param = {
                // key:2304270013,
                key: nodeid,
                metrics: queryName,
                begin: this.queryDate == null ? '' : formatDate(this.queryDate[0], 'yyyy-MM-dd'),
                end: this.queryDate == null ? '' : formatDate(this.queryDate[1], 'yyyy-MM-dd')
            };
            this.getChartData(param)

        },
        getChartData(param) {
            var unit = "";
            forEach(airDetailList, item => {
                if (!item.showIcon && item.to.params.queryParam === this.queryName) {
                    unit = item.unit;
                }
            });
            // const param = {
            //     // key:2304270013,
            //     key: nodeid,
            //     metrics: queryName,

            // };
            get(`/metrics/list?${objectToParams(param)}`).then(res => {
                if (res.data) {
                    if (res.data) {
                        let temp = [];
                        forEach(res.data.rows, (item, index) => {
                            let valueList = [];
                            for (var key in item) {
                                if (this.valueParamList.indexOf(key) !== -1) {
                                    valueList.push(item[key]);
                                }
                            }
                            //  forEach(this.valueParamList,it=>{
                            //      if(it.)
                            //  })
                            if (valueList.length > 0) {
                                temp.push({ value: valueList[0], label: item.receivedAt })
                            }
                            // temp.push({
                            //     rowNum:index,
                            //     FullName:this.type,
                            //     Value:valueList.join("/"),
                            //     ReportTime:item.receivedAt
                            // })
                        });
                        //  this.dataList = temp;
                        if (this.chart) {
                            this.chart.changeData(temp);
                            this.chart.update({
                                data: temp,
                                tooltip: {
                                    formatter: (item) => {
                                        return { name: this.type, value: `${item.value}${unit}` }
                                    }
                                },
                            })

                        } else {
                            const bar = new Area('container', {
                                data: temp,
                                xField: 'label',
                                yField: 'value',
                                xAxis: {
                                    range: [0, 1],
                                    tickCount: 5,
                                },
                                areaStyle: () => {
                                    return {
                                        fill: 'l(270) 0:#ffffff 1:#87dccb',
                                    };
                                },
                                tooltip: {
                                    formatter: (item) => {
                                        return { name: this.type, value: `${item.value}${unit}` }
                                    }
                                },
                                smooth: true
                            });

                            bar.render();
                            this.chart = bar;
                        }

                        // this.node = 'dsff'

                        // this.initOption()
                        //  this.chart.setOption(this.option)
                    } else {
                        // this.chart.hideLoading()
                    }

                }

            }).catch(error => {
                if (this.chart) {
                    this.chart.changeData([]);
                    this.chart.update({
                        data: [],
                    })
                }

            })
        },

    }
}
</script>
<style lang='less' scoped>
.chart {
    height: 220px;
}

.ai-b {
    align-items: baseline;
}
</style>
